import { createFileRoute } from '@tanstack/react-router';
import { ConnectedAppsIndex } from '@/pages/settings/connected-apps/ConnectedAppsIndex';

export const Route = createFileRoute('/_authenticated/_app/settings/connected-apps')({
	component: ConnectedAppsIndex,
});
